import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Trans, useTranslation } from 'react-i18next';
import { StudyType } from '@app/api';
import { LabeledSection } from './LabeledSection';

const useStyles = createUseStyles((theme: Theme) => ({
  sessionInformations: {
    width: '100%',
    marginTop: theme.marginBase * 3,
    borderRadius: theme.borderRadius.std,
    display: 'flex',
    justifyContent: 'space-between',
    [theme.media.mobile]: {
      flexDirection: 'column',
      paddingBottom: theme.marginBase * 3,
      paddingTop: 0,
    },
  },
  block: {
    marginRight: theme.marginBase * 5,
    [theme.media.tablet]: {
      marginRight: theme.marginBase * 3,
    },
    [theme.media.mobile]: {
      marginTop: theme.marginBase * 3,
    },
  },
  incentiveBlock: {
    width: '100%',
  },
  label: {
    ...theme.fonts.label,
    color: theme.colors.inkSecondary,
    marginBottom: theme.marginBase,
  },
  incentiveIcon: {
    fontSize: theme.iconSize.large,
    color: theme.colors.green,
    marginRight: theme.marginBase,
  },
  content: {
    ...theme.fonts.caption,
    color: theme.colors.inkPrimary,
    display: 'flex',
    alignItems: 'flex-start',
    padding: theme.marginBase * 2,
    borderRadius: theme.borderRadius.std,
    backgroundColor: theme.colors.greenMuted,
    width: '100%',
  },
}));

interface Props {
  incentive?: string;
  studyType: StudyType;
  className?: string;
}

export const SessionInformations = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  if (!props.incentive) {
    return null;
  }

  return (
    <div className={classnames(classes.sessionInformations, props.className)}>
      {props.studyType !== StudyType.MODERATED && (
        <div className={classes.block}>
          <p className={classes.label}>
            <Trans i18nKey="application.info.studyType" />
          </p>
          <p className={classes.content}>
            <i
              className={classnames('ri-list-check-2', classes.incentiveIcon)}
            />
            <Trans
              i18nKey={`application.info.studyTypeList.${props.studyType}`}
            />
          </p>
        </div>
      )}
      {props.incentive && (
        <LabeledSection
          label={t('application.info.incentive')}
          className={classes.incentiveBlock}
        >
          <p className={classes.content}>
            <i className={classnames('ri-gift-line', classes.incentiveIcon)} />
            {props.incentive}
          </p>
        </LabeledSection>
      )}
    </div>
  );
};
